import React, { useCallback } from "react";
import { Check, RotateCcw, X } from "lucide-react";
import { cn, getInitials } from "src/lib/utils";
import { ReportReviewPayload, ReviewStatusEnum, UserActionType } from "src/api/UserActionsStatus";
import { reviewerLevelDisplay } from "src/features/userActionsStatus/utils/reviewerMappers";

export const ReviewerItem = React.memo<{
    reviewer: ReportReviewPayload;
    reviewerName: string;
    showStatusIcon: boolean;
    onRemove: (level: UserActionType) => void;
    canRemove: boolean;
    isLoading?: boolean;
}>(({ reviewer, reviewerName, showStatusIcon, onRemove, canRemove, isLoading = false }) => {

    const handleRemove = useCallback(() => {
        if (canRemove && !isLoading) {
            onRemove(reviewer.action_type);
        }
    }, [reviewer.action_type, onRemove, canRemove, isLoading]);

    return (
        <div className="flex items-center gap-3 py-2">
            <div className="h-6 w-6 rounded-full bg-gray-200 flex items-center justify-center text-[10px] font-medium text-gray-700">
                {getInitials(reviewerName)}
            </div>
            <div className="flex-1">
                <div className="text-sm font-medium">{reviewerName}</div>
                <div className="text-xs text-gray-500">{reviewer.review_status.approver}</div>
            </div>
            <div className="flex items-center gap-3">
                {showStatusIcon && (
                    <div className="flex items-center gap-1">
                        {reviewer.review_status.status === ReviewStatusEnum.APPROVED ? (
                            <Check className="h-4 w-4 text-green-600" />
                        ) : (
                            <RotateCcw className="h-4 w-4 text-orange-500" />
                        )}
                    </div>
                )}
                <div className="text-sm min-w-[100px] text-right font-medium text-gray-700">
                    {reviewerLevelDisplay[reviewer.action_type]}
                </div>
                {canRemove ? (
                    <button onClick={handleRemove} disabled={isLoading} className={cn("text-gray-400 hover:text-gray-600 transition-colors p-1 rounded hover:bg-gray-100", isLoading && "opacity-50 cursor-not-allowed")} title="Remove reviewer">
                        <X className="h-3 w-3" />
                    </button>
                ) : (
                    <div className="w-6" />
                )}
            </div>
        </div>
    );
});